import { IBaseIconProps } from "./IBaseIconProps";

export const InformationIcon = ({ color = "#fff" }: IBaseIconProps) => {
  return (
    <svg viewBox="-2 -2 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.029 3 3 7.029 3 12s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm0 1.5a7.5 7.5 0 100 15A7.5 7.5 0 0012 4.5z"
        fill={color}
      />
      <rect x="11.25" y="11" width="1.5" height="6" rx="0.5" fill={color} />
      <circle cx="12" cy="8.5" r="1" fill={color} />
    </svg>
  );
};
